<template>
  <div id="app">
    <router-view />
    <div class="bottom" v-if="$route.path !== '/login'">
      <ButtomNav />
    </div>
  </div>
</template>

<script>
import ButtomNav from "@/components/BottomNav";
export default {
  components: {
    ButtomNav,
  },
};
</script>

<style lang="less">
.bottom{
  height: 30px;
  width: 100%;
  position: absolute;
  bottom: 0px;
}
</style>
